import Image from '@tiptap/extension-image'

// Extend Image to teach @tiptap/markdown how to serialize width/height.
// Plain images → standard `![alt](src)`.
// Sized images → inline HTML `<img …>` (valid CommonMark, Redmine renders it).
export const ResizableImage = Image.extend({
  renderMarkdown(node) {
    const { src = '', alt = '', title, width, height } = node.attrs as {
      src?: string
      alt?: string
      title?: string
      width?: number
      height?: number
    }

    if (width || height) {
      const attrs: string[] = [`src="${src}"`]
      if (alt)
        attrs.push(`alt="${alt}"`)
      if (title)
        attrs.push(`title="${title}"`)
      if (width)
        attrs.push(`width="${width}"`)
      if (height)
        attrs.push(`height="${height}"`)
      return `<img ${attrs.join(' ')}>`
    }

    const titlePart = title ? ` "${title}"` : ''
    return `![${alt}](${src}${titlePart})`
  },
})
